import { render, staticRenderFns } from "./PotentialMemberForm.vue?vue&type=template&id=044eb1ba"
import script from "./PotentialMemberForm.vue?vue&type=script&lang=js"
export * from "./PotentialMemberForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports